import { Reveal } from "./Reveal";

const PILLARS = [
  { title: "Mindset", items: ["Confidence", "Pressure", "Resilience"] },
  { title: "Movement", items: ["Mobility", "Flexibility", "Body awareness"] },
  { title: "Recovery", items: ["Breathwork", "Recovery habits", "Nervous-system regulation"] },
];

const About = () => (
  <section id="about" className="about section-pad" data-testid="about-section">
    <Reveal className="about-inner">
      <p className="eyebrow" data-testid="about-eyebrow">The practice</p>
      <h2 className="section-heading">What Mindful Athlete Is</h2>
      <p className="about-lead">
        Mindful Athlete is a community and performance platform helping athletes develop the skills they need both in
        sport and in life. We bring together mindset and mental performance, athletic mobility, recovery and breathwork
        to help athletes build confidence, handle pressure, move better, recover smarter and become more resilient.
      </p>
    </Reveal>
    <div className="pillars">
      {PILLARS.map((pillar, i) => (
        <Reveal key={pillar.title} delay={i * 0.12} className="pillar" data-testid={`pillar-${pillar.title.toLowerCase()}`}>
          <h3>{pillar.title}</h3>
          <ul>
            {pillar.items.map((item) => (
              <li key={item} data-testid={`pillar-${pillar.title.toLowerCase()}-${item.toLowerCase().replaceAll(" ", "-")}`}>
                {item}
              </li>
            ))}
          </ul>
        </Reveal>
      ))}
    </div>
  </section>
);

export default About;
